module.exports = __webpack_public_path__ + "img/DSZ_1499_thumb.1f03676f.jpg";